import React, { useCallback, useEffect, useState } from "react";
import searchIcon from "../../assets/svgs/Transactions-icons/search.svg";
import filterIcon from "../../assets/svgs/Transactions-icons/filter.svg";
import BpsButton from "../../ui/Button/Button";
import cloud from "../../assets/svgs/Transactions-icons/cloud.svg";
import addNewIcon from "../../assets/svgs/Transactions-icons/add.svg";
import { Input, Dropdown, Spin, message } from "antd";
import FilterModal from "../../components/FilterGroup/FilterModal";
import addIcon from "../../assets/svgs/addIcon.svg";
import AlertsModal from "../../components/Modal/AlertsModal/AlertsModal";
import AdministratorsModal from "../../components/Modal/AdministratorsModal/AdministratorsModal";
import SwVendorModal from "../../components/SwVendorModal/SwVendorModal";
import SwEventModal from "../../components/SwEventModal/SwEventModal";
import SwEventDrawer from "../../components/SwEventDrawer/SwEventDrawer";
import { useDispatch } from "react-redux";
import useDebounce from "./../../hooks/useDebounce";
import { LoadingOutlined } from "@ant-design/icons";
import { exportToCSV, sleep } from "../../utils/utils";


// Move this OUTSIDE the Filterbox component, before it
const SearchInput = ({ value, onChange, searchIsLoading, className = "" }) => (
  <Input
    value={value}
    onChange={onChange}
    prefix={<i><img src={searchIcon} alt="/" /></i>}
    type="search"
    className={`bps-search-input ${className}`}
    placeholder="Search..."
    suffix={
      searchIsLoading && (
        <Spin
          style={{ color: "#2E9E5B" }}
          indicator={<LoadingOutlined size={12} />}
        />
      )
    }
  />
);


const Filterbox = ({
  displayFilter,
  showButtons,
  type,
  filterType,
  showRefresh,
  showAdmin,
  searchAction,
  searchActionData,
  searchIsLoading = false,
  applyFilterAction,
  applyFilterActionData,
  dataToExport = [],
  exportFileName = "data.csv",
  showExportButton = true,
  showAddVendorButton = false,
  showAddEventButton = false,
  showAddEventDrawer = false,
  eventDrawerMode = "add",
  eventData = null,
}) => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [addVendorOpen, setAddVendorOpen] = useState(false);
  const [addEventOpen, setAddEventOpen] = useState(false);
  const [addEventDrawerOpen, setAddEventDrawerOpen] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);
  const showAddVendorModal = () => setAddVendorOpen(true);
  const onAddVendorClose = () => setAddVendorOpen(false);
  const showAddEventModal = () => setAddEventOpen(true);
  const onAddEventClose = () => setAddEventOpen(false);
  const showAddEventDrawerFunc = () => setAddEventDrawerOpen(true);
  const onAddEventDrawerClose = () => setAddEventDrawerOpen(false);

  function handleVisibleChange(visible) {
    setVisible(visible);
  }

  const handleApplyFilter = (values) => {
    if (typeof applyFilterAction === "function") {
      dispatch(applyFilterAction({ ...values, ...applyFilterActionData }));
      setVisible(!visible);
    }
  };

  const handleDataExport = useCallback(() => {
    setIsExporting(true);
    let data = typeof dataToExport === "function" ? dataToExport() : dataToExport;
    exportToCSV(data, exportFileName);
    sleep(1000).then(() => {
      setIsExporting(false);
      message.success("Data exported successfully");
    });
  }, [dataToExport, exportFileName]);

  const style = { display: displayFilter };

  const menu = (
    <FilterModal
      onClick={handleVisibleChange}
      visible={visible}
      setVisible={setVisible}
      onApplyFilter={handleApplyFilter}
      type={type}
    />
  );

  const debouncedSearchValue = useDebounce(searchValue);

  useEffect(() => {
    if (typeof searchAction === "function" && debouncedSearchValue !== null) {
      dispatch(searchAction({ search_term: debouncedSearchValue, ...searchActionData }));
    }
  }, [dispatch, debouncedSearchValue]);


  const ActionButtons = () => (
    <>
      {showAdmin && (
        <>
          <BpsButton
            label="New admin"
            customClass="filter-primary_button"
            shape="rounded"
            buttonType="primary"
            icon={addIcon}
            displayIcon={true}
            onClick={showDrawer}
          />
          <AdministratorsModal open={open} onClose={onClose} />
        </>
      )}
      {showRefresh && (
        <>
          <BpsButton
            label="New alert"
            customClass="filter-primary_button"
            shape="rounded"
            buttonType="primary"
            icon={addIcon}
            displayIcon={true}
            onClick={showDrawer}
          />
          <AlertsModal open={open} onClose={onClose} />
        </>
      )}
      {!showRefresh && !showAdmin && showExportButton && (
        <BpsButton
          label="Export CSV"
          customClass="bps-filterbox__header_button"
          buttonType="transparent"
          icon={cloud}
          displayIcon={true}
          loading={isExporting}
          onClick={handleDataExport}
        />
      )}
      {!showRefresh && !showAdmin && showAddVendorButton && (
        <BpsButton
          label="Add New Vendor"
          customClass="bps-filterbox__header_button"
          buttonType="transparent"
          icon={addNewIcon}
          displayIcon={true}
          onClick={showAddVendorModal}
        />
      )}
      {!showRefresh && !showAdmin && showAddEventButton && (
        <BpsButton
          label="Add New Event"
          customClass="bps-filterbox__header_button"
          buttonType="transparent"
          icon={addNewIcon}
          displayIcon={true}
          onClick={showAddEventModal}
        />
      )}
      {!showRefresh && !showAdmin && showAddEventDrawer && (
        <BpsButton
          label="Create new event"
          customClass="bps-filterbox__header_button"
          buttonType="transparent"
          icon={addNewIcon}
          displayIcon={true}
          onClick={showAddEventDrawerFunc}
        />
      )}
    </>
  );

  return (
    <div className="Filterbox">

      {/* ── Mobile bar — search + filter toggle, always visible ── */}
      <div className="bps-filterbox__mobile-bar">
        <SearchInput
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          searchIsLoading={searchIsLoading}
        />
        <button
          className={`bps-filterbox__filter-toggle ${filtersVisible ? "active" : ""}`}
          onClick={() => setFiltersVisible(!filtersVisible)}
        >
          <img src={filterIcon} alt="filter" />
        </button>
      </div>

      {/* ── Mobile collapsible — filter dropdown + action buttons only ── */}
      <div className={`bps-filterbox__collapsible ${filtersVisible ? "open" : ""}`}>
        <div className="bps-filterbox__collapsible-inner">
          <div className="bps-filterbox__header_container" style={style}>
            <label>Select Filter</label>
            {visible && <div className="overlay" />}
            <Dropdown
              overlay={menu}
              open={visible}
              onOpenChange={handleVisibleChange}
              trigger={["click"]}
            >
              <button className="bps-filterbox-filter">
                Filtered by: {filterType}
                <span className="filter-icon">
                  <img src={filterIcon} alt="/" />
                </span>
              </button>
            </Dropdown>
          </div>
          {showButtons && (
            <div className="filter-cloud-btn">
              <ActionButtons />
            </div>
          )}
        </div>
      </div>

      {/* ── Desktop layout — full header ── */}
      <div className="bps-filterbox__desktop-header">
        <div className="bps-filterbox__header_inner">
          <div className="bps-filterbox__header_container" style={style}>
            <label>Select Filter</label>
            {visible && <div className="overlay" />}
            <Dropdown
              overlay={menu}
              open={visible}
              onOpenChange={handleVisibleChange}
              trigger={["click"]}
            >
              <button className="bps-filterbox-filter">
                Filtered by: {filterType}
                <span className="filter-icon">
                  <img src={filterIcon} alt="/" />
                </span>
              </button>
            </Dropdown>
          </div>
          <div className="bps-filterbox__header_container">
            <label>Search</label>
            <SearchInput
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              searchIsLoading={searchIsLoading}
            />
          </div>
        </div>
        {showButtons && (
          <div className="filter-cloud-btn">
            <ActionButtons />
          </div>
        )}
      </div>

      {/* Modals & Drawers */}
      <SwVendorModal open={addVendorOpen} onClose={onAddVendorClose} />
      <SwEventModal open={addEventOpen} onClose={onAddEventClose} />
      <SwEventDrawer
        open={addEventDrawerOpen}
        onClose={onAddEventDrawerClose}
        mode={eventDrawerMode}
        eventData={eventData}
      />
    </div>
  );
};

Filterbox.defaultProps = {
  showButtons: true,
  filterType: "transaction type",
  showRefresh: false,
  showAdmin: false,
  showAddEventDrawer: false,
  eventDrawerMode: "add",
  eventData: null,
};

export default Filterbox;